__turbopack_context__.v({
  "arrowIcon": "arrow-icon-module-scss-module__K--68W__arrowIcon",
  "arrowIconImage": "arrow-icon-module-scss-module__K--68W__arrowIconImage",
  "down": "arrow-icon-module-scss-module__K--68W__down",
  "left": "arrow-icon-module-scss-module__K--68W__left",
  "primary": "arrow-icon-module-scss-module__K--68W__primary",
  "quaternary": "arrow-icon-module-scss-module__K--68W__quaternary",
  "right": "arrow-icon-module-scss-module__K--68W__right",
  "secondary": "arrow-icon-module-scss-module__K--68W__secondary",
  "up": "arrow-icon-module-scss-module__K--68W__up",
  "white": "arrow-icon-module-scss-module__K--68W__white",
});
